export function initPort(app) {
  app.ports.asBytes &&
  app.ports.asBytes.subscribe(function(data) {
    try {
      window.open(URL.createObjectURL(new Blob( [new Uint8Array(data.bytes)], {type: data.mime})));
    } catch (e) {
      console.log(e);
    }
  });

  app.ports.asUrl &&
  app.ports.asUrl.subscribe(function(url) {
    window.open(url);
  });
}
